import { bool, func, number, string } from 'prop-types';
import * as classNames from './ProductPrice.module.css';

const ProductPrice = ({
  name,
  salePrice,
  retailPrice,
  replenishmentPrice,
  isBoost = false,
  formatSalePriceWithQty,
  priceWithCurrency,
}) => {
  if (name === 'FFF Picks - 1 Per Box') {
    return (
      <div data-testid="product-price-picks-one" className={classNames.price}>
        <span>?</span>
      </div>
    );
  }
  return (
    <div data-testid="product-price-container" className={classNames.price}>
      {!!replenishmentPrice && <span>{formatSalePriceWithQty(replenishmentPrice)} </span>}
      {!salePrice && !!retailPrice && <span>{formatSalePriceWithQty(retailPrice)} </span>}
      {!!salePrice && <span>{formatSalePriceWithQty(salePrice)} </span>}
      {(salePrice === 0 || retailPrice === 0) && <span>{formatSalePriceWithQty(0)}</span>}
      {!isBoost && !!retailPrice && !!salePrice && (
        <span className={classNames.retailPrice}>{priceWithCurrency(retailPrice)}</span>
      )}
    </div>
  );
};

ProductPrice.propTypes = {
  name: string.isRequired,
  salePrice: number,
  retailPrice: number,
  replenishmentPrice: number,
  isBoost: bool,
  formatSalePriceWithQty: func.isRequired,
  priceWithCurrency: func.isRequired,
};

export default ProductPrice;
